import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const DEVICE_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const colSize = PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.number,
  PropTypes.string,
  PropTypes.oneOf(['auto']),
]);

const stringOrNumber = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
]);

const column = PropTypes.oneOfType([
  colSize,
  PropTypes.shape({
    size: colSize,
    order: stringOrNumber,
    offset: stringOrNumber,
  }),
]);

const propTypes = {
  bsPrefix: PropTypes.string,
  as: PropTypes.elementType,
  xs: column,
  sm: column,
  md: column,
  lg: column,
  xl: column,
  xxl: column,
};

export function useCol({
  as,
  className,
  ...attrs
}) {
  const bsPrefix = 'col';

  const spans = [];
  const classes = [];

  const htmlAttrs = { ...attrs };
  DEVICE_SIZES.forEach((brkPoint) => {
    const propValue = attrs[brkPoint];
    delete htmlAttrs[brkPoint];

    let span;
    let offset;
    let order;

    if (typeof propValue === 'object' && propValue != null) {
      ({ span, offset, order } = propValue);
    } else {
      span = propValue;
    }

    const infix = brkPoint !== 'xs' ? `-${brkPoint}` : '';

    if (span) {
      spans.push(
        span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`,
      );
    }

    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });

  return [
    { ...htmlAttrs, className: classNames(className, ...spans, ...classes) },
    {
      as,
      bsPrefix,
      spans,
    },
  ];
}

const Col = React.forwardRef((props, ref) => {
  const [
    { className, ...colProps },
    { as: Component = 'div', bsPrefix, spans },
  ] = useCol(props);

  return (
    <Component
      {...colProps}
      ref={ref}
      className={classNames(className, !spans.length && bsPrefix)}
    />
  );
});

Col.displayName = 'Col';
Col.propTypes = propTypes;

export default Col;
